<button
  pButton
  pRipple
  [pTooltip]="languageKey.EDIT | translateKey"
  icon="pi pi-pencil"
  class="p-button-rounded p-button-raised p-button-primary mr-2"
></button>
